// src/features/profile/Sponsoring/components/OfferCard.tsx

import React, { FC } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import { InlineIcon } from "@iconify/react";
import { TSubscriptionPlan } from "@/features/profile/types/types";

type OfferCardProps = {
  offer: TSubscriptionPlan;
  price: number;
  onSubscribe: () => void;
};

/**
 * Affiche une carte avec les détails de l’offre
 */
const OfferCard: FC<OfferCardProps> = ({ offer, price, onSubscribe }) => {
  return (
    <Card className="offer-card" elevation={0}>
      <CardContent className="offer-card-content">
        <Typography variant="h5" className="offer-name">
          Propulse ton profil en tête !
        </Typography>
        <Typography variant="h6" className="offer-description">
          {offer.description}
        </Typography>
        <Typography variant="h5" className="offer-price">
          {price}
          {offer.currency === "EUR" && " €"}
          {offer.currency === "USD" && " $"}
        </Typography>
        <Typography variant="body1" className="offer-validity">
          Durée : {offer.duration}
        </Typography>
      </CardContent>

      <CardActions>
        <Button
          variant="contained"
          color="primary"
          className="subscribe-btn"
          onClick={onSubscribe}
          endIcon={<InlineIcon icon="ic:baseline-shopping-cart" />}
        >
          Souscrire
        </Button>
      </CardActions>
    </Card>
  );
};

export default OfferCard;
